import styled from 'styled-components';

export const StyledContainer = styled.main.attrs({
  className: 'text-gray-400 bg-gray-900 body-font',
})``;
export const StyledProgressBar = styled.div`
  position: fixed;
  top: 0;
  height: 3px;
  width: 100%;
  z-index: 9999;
`;
